var _defs, _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerPortrait15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4583in",
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 6,
    gradientTransform: "matrix(2.9598 0 0 4.6483 -971.19 -788.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a19a86",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 8,
    gradientTransform: "matrix(0 0 0 0 20.949 -188.22)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9c2b5",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 9,
    gradientTransform: "matrix(0 0 0 0 44.525 198.06)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3cdc3",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2-4",
    gradientTransform: "matrix(0 0 0 0 -123.69 -377.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f4b41",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1385",
    x1: 54.811,
    x2: 91.853,
    y1: 32.815,
    y2: 32.815,
    gradientTransform: "translate(80.381 117.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3a995",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4-27",
    x1: 186.43,
    x2: 189.99,
    y1: 121.75,
    y2: 121.75,
    gradientTransform: "translate(-40.832 41.198)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e7867",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4721",
    x1: 136.44,
    x2: 154.6,
    y1: 152.27,
    y2: 152.27,
    gradientTransform: "matrix(1.3369 0 0 .74799 -40.832 41.198)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4723",
    x1: 132.18,
    x2: 136.82,
    y1: 163.87,
    y2: 163.87,
    gradientTransform: "matrix(1.4464 0 0 .69136 -40.832 41.198)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4725",
    x1: 161.9,
    x2: 166.28,
    y1: 120.76,
    y2: 120.76,
    gradientTransform: "matrix(1.1638 0 0 .85923 -40.832 41.198)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4727",
    x1: 168.01,
    x2: 172.39,
    y1: 120.76,
    y2: 120.76,
    gradientTransform: "matrix(1.1638 0 0 .85923 -40.832 41.198)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4729",
    x1: 170.62,
    x2: 175.55,
    y1: 118.44,
    y2: 118.44,
    gradientTransform: "matrix(1.1444 0 0 .8738 -40.832 41.198)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#2-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4731",
    x1: 164.41,
    x2: 169.34,
    y1: 118.44,
    y2: 118.44,
    gradientTransform: "matrix(1.1444 0 0 .8738 -40.832 41.198)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#2-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4733",
    x1: 124.3,
    x2: 140.86,
    y1: 170.52,
    y2: 170.52,
    gradientTransform: "matrix(1.4674 0 0 .68149 -40.832 41.198)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#2-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4735",
    x1: 99.019,
    x2: 100.1,
    y1: 205.75,
    y2: 205.75,
    gradientTransform: "matrix(1.9534 0 0 .51193 -40.832 41.198)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#2-4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135.19 -131.64)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215.9,
    height: 279.4,
    fill: "#fcfcfc",
    style: {
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135.19 -131.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.19,
    y: 131.64,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "url(#linearGradient1385)",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.74 155.09a12.143 12.143 0 0 0-6.0999 1.6268 12.143 12.143 0 0 0-6.0715 10.517v1.4449h24.287v-1.4449a12.143 12.143 0 0 0-6.0715-10.517 12.143 12.143 0 0 0-6.0441-1.6268z",
    fill: "url(#linearGradient4721)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.36,
    y: 154.49,
    width: 6.7016,
    height: 3.2032,
    fill: "url(#linearGradient4723)",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 5.3339,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m153.71 154.88-1.6601 10.181 0.4699 3.6184h2.3807l0.4699-3.6184z",
    fill: "#615b4c",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.01,
    y: 150.42,
    width: 5.409,
    height: 7.7654,
    ry: 2.7045,
    fill: "#968c77",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.44,
    y: 137.99,
    width: 14.547,
    height: 16.552,
    ry: 7.2734,
    fill: "#968c77",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 144.96,
    width: 5.0969,
    height: 3.7629,
    ry: 0.19709,
    fill: "url(#linearGradient4725)",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.18,
    cy: 146.81,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.18,
    cy: 146.81,
    rx: 0.885,
    ry: 1.2626,
    fill: "#4f4b41",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 154.7,
    y: 144.96,
    width: 5.0969,
    height: 3.7629,
    ry: 0.19709,
    fill: "url(#linearGradient4727)",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.25,
    cy: 146.81,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154.7,
    y: 144.96,
    width: 5.0969,
    height: 3.7629,
    ry: 0.19709,
    fill: "none",
    stopColor: "#000000",
    stroke: "url(#linearGradient4729)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.25,
    cy: 146.81,
    rx: 0.885,
    ry: 1.2626,
    fill: "#4f4b41",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#615b4c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m153.74 149.3a5.3545 2.764 0 0 0-5.3547 2.7637 5.3545 2.764 0 0 0 0.0114 0.1788c1.3255 1.4171 3.213 2.3017 5.3154 2.3017 2.135 0 4.0492-0.9111 5.3774-2.3668a5.3545 2.764 0 0 0 5e-3 -0.11369 5.3545 2.764 0 0 0-5.3542-2.7637z",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.65 149.46a2.764 5.3545 72.091 0 0-3.1218 3.8385 2.764 5.3545 72.091 0 0 0.0506 0.13177c1.4466-0.90641 2.5484-2.3072 3.0711-3.9703z",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.77 149.46a5.3545 2.764 17.909 0 1 3.1218 3.8385 5.3545 2.764 17.909 0 1-0.0506 0.13177c-1.4466-0.90641-2.5484-2.3072-3.0711-3.9703z",
    stopColor: "#000000"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 144.96,
    width: 5.0969,
    height: 3.7629,
    ry: 0.19709,
    fill: "none",
    stopColor: "#000000",
    stroke: "url(#linearGradient4731)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("path", {
    d: "m146.59 157.4a12.143 12.143 0 0 0-5.0193 9.8345v1.4449h24.287v-1.4449a12.143 12.143 0 0 0-4.9646-9.7942l-7.1314 7.1314z",
    fill: "url(#linearGradient4733)",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 152.59,
    y: 146.53,
    width: 2.1134,
    height: 0.55387,
    fill: "url(#linearGradient4735)",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("g", null, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 152.57,
    y: 157.93,
    width: 2.2884,
    height: 1.6962,
    ry: 0.70691,
    fill: "#615b4c",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-.70711 .70711 .70711 .70711 0 0)",
    x: -1.8153,
    y: 220.31,
    width: 4.8054,
    height: 3.1443,
    fill: "#d3cdc3",
    stopColor: "#000000",
    stroke: "url(#9)",
    strokeOpacity: 0.019685,
    strokeWidth: 5.324,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(45)",
    x: 215.56,
    y: 2.919,
    width: 4.8412,
    height: 3.1443,
    fill: "#d3cdc3",
    stopColor: "#000000",
    stroke: "url(#9)",
    strokeOpacity: 0.019685,
    strokeWidth: 5.324,
    style: {
      paintOrder: "markers fill stroke"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 147.38,
    cy: 164.72,
    r: 1.7805,
    fill: "url(#4-27)",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait15);
export default __webpack_public_path__ + "static/media/player-portrait-15.38861fa696ba1b4513cd92779760b4ec.svg";
export { ForwardRef as ReactComponent };